import { useParams } from "react-router-dom";
import { useStores } from "../store";
import { useCallback } from "react";
import { CookieGroupModel } from "../models";
const useRouteCookieGroup = ()=>{
    const { cookieGroup } = useParams();
    const { cookieStore } = useStores();
    // Get cookie group or return draft object
    const id = isNaN(+cookieGroup) ? 0 : +cookieGroup;
    const queried = !!cookieGroup;
    const group = cookieStore.groups.entries.get(id) || new CookieGroupModel(cookieStore.groups, {
        id: 0
    });
    const link = `#/cookies`;
    const editLink = useCallback((param)=>{
        let { key } = param;
        return `#/cookies/${group.key}/edit/${key}`;
    }, [
        group
    ]);
    const addCookieLink = `#/cookies/${group.key}/new`;
    return {
        group,
        id,
        queried,
        fetched: group.key !== 0,
        link,
        editLink,
        addCookieLink
    };
};
export { useRouteCookieGroup };
